import { ActionTypes } from 'utils/constants';
import axios from 'axios';
import { getEnvVar } from 'utils/get-env-var';

export const toggleLoginModal = () => {
    return (dispatch, getState) => {
        const state = getState();
        const open = state.user.login.modalOpen;
        
        document.body.style.overflow = open ? 'visible' : 'hidden';

        dispatch({
            type: ActionTypes.TOGGLE_LOGIN_MODAL
        });
    };
};

// Opens the login modal while flagging that it was launched from the join
// flow, so a successful login can resume the checkout redirect.
export const openLoginFromJoin = () => dispatch => {
    dispatch(toggleLoginModal());
    dispatch({ type: ActionTypes.SET_LOGIN_FROM_JOIN });
};

export const login = payload => (
    {
        type: ActionTypes.LOGIN,
        payload: axios.post(`${getEnvVar('API_BASE')}/login`, payload)
    }
);
